export default __webpack_public_path__ + "static/media/product-staking.e7901d7b.png";